import { useQuery } from "@tanstack/react-query";
import { getHomeApiData } from "components/Service/homeApi";

export const useHomeSection = (uuid: string) => {
  return useQuery({
    queryKey: ["home-section", uuid],
    queryFn: () => getHomeApiData(uuid),
    enabled: !!uuid,
  });
};

export const useSection = (uuid: string) => {
  return useQuery({
    queryKey: ["section", uuid],
    queryFn: () => getHomeApiData(uuid),
    enabled: !!uuid,
  });
};

